<div *ngIf="navigate$ | async"></div>

<div *ngIf="auth.user$ | async as user"></div>